import { createSelector } from "reselect";

const tenants = (state) => state.admin.tenants;
const totalTenants = (state) => state.admin.totalTenants;

export const selectTenants = createSelector(tenants, (tenants) => tenants);

export const selectTotalTenants = createSelector(totalTenants, (totalTenants) => totalTenants);

export const selectTenantsTechnicalName = createSelector(
    tenants,
    (tenants) => tenants?.map((tenant) => tenant.TechnicalName) || [],
);
